import saveAs from 'file-saver';
import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { loadAttachmentsRequest, loadAttachmentsFailure } from './actions';

export function* loadAttachments({ payload }: ReturnType<typeof loadAttachmentsRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}ObterAnexo&token=${state.auth.token}`,
      {
        protocolo: payload.protocolo,
        mensagem: payload.mensagem,
      },
      {
        responseType: 'blob',
      }
    );
    const blob = new Blob([response.data], { type: 'application/octet-stream' });
    saveAs(blob, 'anexo.zip');
  } catch (error: any) {
    yield put(loadAttachmentsFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao tentar fazer o download do arquivo, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
